import React from 'react';
import useMetaLayoutContext
  from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  AuthenticationLayout,
} from 'Views/Authentication/Components';
import fr from 'facet-rest';
import {
  FDLetterhead,
  FDList,
  FDListItem,
  FDListItemIcon,
  FDListItemText,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import PropTypes
  from 'prop-types';
import {
  AuthenticationLayoutLoading,
} from 'Views/Authentication/Components/AuthenticationLayoutLoading';

export const RoleSelectionLayout = ({ collection, setCollection }) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const userRoles = resource.withRelationship(fr.relationships.userRoles.name, (rel) => {
    return rel.data.map(resourceIdentifier => collection.included().findResource(resourceIdentifier));
  }, () => []);

  const selectUserRole = async (userRole) => {
    const coll = await userRole.link('self').post();
    await setCollection(coll);
  };

  // Somehow a 'user' resource is ending up in this layout after a role is selected, even
  // though this layout isn't assigned to resources of type 'user'.
  if (resource.type() !== 'RoleSelectionPage') {
    return <AuthenticationLayoutLoading />;
  }

  return (
    <AuthenticationLayout>
      <FDStack direction={'column'} justifyContent={'center'} maxWidth={'100vw'}>
        <FDLetterhead
          avatarSize="md"
          image={resource.relationship(fr.relationships.facetIcon.name)?.link('related').url()}
          title={resource.attr('title')}
        >
          <FDTitleText value={resource.attr('description')} />
          <FDList>
            {userRoles.map((userRole) => (
              <FDListItem
                key={userRole.id()}
                onClick={() => selectUserRole(userRole)}
              >
                <FDListItemIcon icon="person" />
                <FDListItemText
                  primaryText={userRole.attr('emailAddress')}
                  secondaryText={userRole.attr('role')}
                />
              </FDListItem>
            ))}
          </FDList>
        </FDLetterhead>
      </FDStack>
    </AuthenticationLayout>
  );
};

RoleSelectionLayout.propTypes = {
  collection: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
};
